<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-group row">
      <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist 
              [ModelName]="'user'" 
              [GetName]="'GetByOrgJedId'"
              [GetParameters]="parameterList" 
              [ModelProperty]="'FirstName,UserName'" 
              formControlName="UserId"
              [Label]="'USERPROVAJDER.USER.SINGULAR'" 
              [ngClass]="{'is-invalid': submitted && fc.UserId.invalid}"
              [Position]="'left'" >
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.UserId.invalid">
                <span *ngFor="let validation of errorMessages.UserId">
                  <span class="error-message" *ngIf="fc.UserId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div> 
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist 
              [ModelName]="'firma'" 
              [GetName]="'GetByOrgJedID'"
              [GetParameters]="parameterList" 
              [ModelProperty]="'Naziv'" 
              formControlName="FirmaID"
              [Label]="'USERPROVAJDER.FIRMA.SINGULAR'" 
              [ngClass]="{'is-invalid': submitted && fc.FirmaID.invalid}"
              [Position]="'left'" 
              [AutoSelect]="'true'">
              </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.FirmaID.invalid">
                <span *ngFor="let validation of errorMessages.FirmaID">
                  <span class="error-message" *ngIf="fc.FirmaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div> 
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtUsername"
                formControlName="Username"
                #focusElement
                [MaxLength]="100"
                [ngClass]="{'is-invalid': submitted && fc.Username.invalid}"
                [Label]="'USERPROVAJDER.DOCLOOP.USERNAME.SINGULAR'">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Username.invalid">
                <span *ngFor="let validation of errorMessages.Username">
                  <span class="error-message" *ngIf="fc.Username.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div> 
            </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtPassword"
                  formControlName="Password"
                  #focusElement
                  [MaxLength]="100"
                  [Label]="'USERPROVAJDER.DOCLOOP.PASSWORD.SINGULAR'"
                  [ngClass]="{'is-invalid': submitted && fc.Password.invalid}">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Password.invalid">
                  <span *ngFor="let validation of errorMessages.Password">
                    <span class="error-message" *ngIf="fc.Password.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div> 
              </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <yt-input
                    [Type]="'text'"
                    name="txtDocloopSoftwareId"
                    formControlName="DocloopSoftwareId"
                    #focusElement
                    [MaxLength]="50"
                    [Label]="'USERPROVAJDER.DOCLOOPSOFTWAREID.SINGULAR'">
                  </yt-input>
                </div>
                </div>
              </div>
          <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-dropdown-picklist 
                      [ModelName]="'provajder'" 
                      [GetName]="'get'"
                      [GetParameters]="[ {Name: 'tipEdokumenta', Value: 'efakture'}]" 
                      [ModelProperty]="'Naziv'" 
                      formControlName="SefProvajderId"
                      [Label]="'USERPROVAJDER.EFAKTURA.PROVAJDER.SINGULAR'" 
                      [Position]="'left'"
                      [AllowAddNew]="false"
                      [ngClass]="{'is-invalid': submitted && fc.SefProvajderId.invalid}"
                      (OnItemSelected)="onProvajderSelected($event)"
                      [TableColumns]="[{ name: 'Naziv', label: 'PROVAJDER.NAZIV.SINGULAR', visible: true, canHide: false },
                                      { name: 'Url', label: 'PROVAJDER.URL.SINGULAR', visible: true, canHide: false }]">
                      </yt-dropdown-picklist>
                      <div class="form-error" *ngIf="submitted && fc.SefProvajderId.invalid">
                        <span *ngFor="let validation of errorMessages.SefProvajderId">
                          <span class="error-message" *ngIf="fc.SefProvajderId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div> 
                    </div>
                  </div>
                </div>
               <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-dropdown-picklist 
                      [ModelName]="'provajder'" 
                      [GetName]="'get'"
                      [GetParameters]="[ {Name: 'tipEdokumenta', Value: 'eotpremnica'}]" 
                      [ModelProperty]="'Naziv'" 
                      formControlName="EotprProvajderId"
                      [Label]="'USERPROVAJDER.EOTPREMNICA.PROVAJDER.SINGULAR'" 
                      [Position]="'left'"
                      [AllowAddNew]="false"
                      (OnItemSelected)="onProvajderSelected($event)"
                      [TableColumns]="[{ name: 'Naziv', label: 'PROVAJDER.NAZIV.SINGULAR', visible: true, canHide: false },
                                      { name: 'EotpremnicaUrl', label: 'PROVAJDER.URL.SINGULAR', visible: true, canHide: false }]">
                      </yt-dropdown-picklist> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div class="col-md-12">
                <div class="form-group row">
                <div class="col-md-6">
                    <yt-input
                      [Type]="'text'"
                      name="txtApiKey"
                      formControlName="ApiKey"
                      #focusElement
                      [MaxLength]="128"
                      [Label]="'USERPROVAJDER.APIKEY.SINGULAR'"
                      [ngClass]="{'is-invalid': submitted && fc.ApiKey.invalid}">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.ApiKey.invalid">
                      <span *ngFor="let validation of errorMessages.ApiKey">
                        <span class="error-message" *ngIf="fc.ApiKey.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div> 
                  </div>

                  <div class="col-md-6">
                    <yt-input
                      [Type]="'text'"
                      name="txtEOtpremnicaApiKey"
                      formControlName="EOtpremnicaApiKey"
                      #focusElement
                      [MaxLength]="128"
                      [Label]="'USERPROVAJDER.EOTPREMNICAAPIKEY.SINGULAR'"
                      [ngClass]="{'is-invalid': submitted && fc.EOtpremnicaApiKey.invalid}">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.EOtpremnicaApiKey.invalid">
                      <span *ngFor="let validation of errorMessages.EOtpremnicaApiKey">
                        <span class="error-message" *ngIf="fc.EOtpremnicaApiKey.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div> 
                  </div>

                  </div>
                </div>
                <div class="form-group row" style="padding-left: 20px;">
                  <div class="col-md-1">
                    <input
                      style="width: 20px;"
                      type="checkbox"
                      name="chkActive"
                      class="form-control"
                      formControlName="IsActive"
                      autocomplete="off"
                      id="chkActive"
                      >
                  </div>
                  <label class="col-form-label col-2" for="chkActive"><span translate="USERPROVAJDER.ISACTIVE.SINGULAR"></span></label>
                </div>
    </div>
  </form>
</div>
